var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section-container"
  }, _vm._l((_vm.sections), function(section, sectionIndex) {
    return _c('div', {
      key: section.title,
      staticClass: "section"
    }, [_c('h3', {
      staticClass: "section-title",
      attrs: {
        "id": section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('div', {
      staticClass: "piece-list"
    }, _vm._l((section.pieces), function(piece, pieceIndex) {
      return _c('piece', {
        key: piece.url,
        attrs: {
          "piece": piece,
          "img-prefix": _vm.imgPrefix
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectPiece(sectionIndex, pieceIndex)
          }
        }
      })
    }))])
  })), _vm._v(" "), (_vm.selected) ? _c('modal', {
    attrs: {
      "urlPrefix": _vm.imgPrefix,
      "piece": _vm.sections[_vm.selected.section].pieces[_vm.selected.piece]
    },
    on: {
      "close": function($event) {
        _vm.selected = null
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a69b2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryEdit.vue
// module id = fN3O
// module chunks = 1